export default __webpack_public_path__ + "static/media/redeem-left.901193ef.svg";